import { useCallback, useEffect, useMemo, useState } from 'react';

import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';

export const useTrackingLoginWithPhoneNumber = () => {
  const currentSiteName = SitecoreContextFactoryService.getValueContextItem('site')?.name;

  const initialTrackingDataValues = {
    isLoginWithPhoneFirst: false,
    errorMessage: null
  };
  const [trackingLoginWithPhoneData, setTrackingLoginWithPhoneData] = useState(initialTrackingDataValues);
  const sessionStorageKey = useMemo(() => `${currentSiteName}-login-tracking`, [currentSiteName]);

  useEffect(() => {
    const trackingDataFromStorage = getTrackingData();
    if (trackingDataFromStorage) setTrackingLoginWithPhoneData(trackingDataFromStorage);
  }, []);

  function getTrackingData() {
    let trackingDataResult = null;
    if (typeof window !== 'undefined') {
      const rawData = window.sessionStorage.getItem(sessionStorageKey);
      if (rawData) trackingDataResult = JSON.parse(rawData);
    }

    return trackingDataResult;
  }

  const handleSaveTrackingDataToStorage = useCallback(
    ({ isLoginWithPhoneFirst, errorMessage }) => {
      let trackingDataTemp = { ...trackingLoginWithPhoneData };

      if (typeof window !== 'undefined') {
        if (isLoginWithPhoneFirst !== undefined) trackingDataTemp.isLoginWithPhoneFirst = isLoginWithPhoneFirst;

        if (errorMessage !== undefined) trackingDataTemp.errorMessage = errorMessage;

        window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(trackingDataTemp));
      }

      setTrackingLoginWithPhoneData(trackingDataTemp);
    },
    [trackingLoginWithPhoneData, sessionStorageKey]
  );

  const handleRemoveTrackingDataFromStorage = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(sessionStorageKey);
    }
  }, []);

  return {
    trackingLoginWithPhoneData,
    onSaveTrackingDataToStorage: handleSaveTrackingDataToStorage,
    onRemoveTrackingDataFromStorage: handleRemoveTrackingDataFromStorage,
    onGetTrackingLoginWithPhoneFirst: getTrackingData
  };
};
